"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateRangeDisplayFormats = void 0;
exports.dateRangeDisplayFormats = [
    "compact",
    "standard",
    "long",
    "pill",
];
